import { apiRequest } from "../../index";
import config from "../../../../config";

const { VCHAT_API } = config;
const api = `${VCHAT_API}/meetings`;

export async function getMeetings() {
  try {
    const response = await apiRequest(`${api}/`, "GET");
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getMeeting(meetingId) {
  try {
    const response = await apiRequest(`${api}/${meetingId}`, "GET");
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getCreatorMeetings({ creator, classroom }) {
  const response = await apiRequest(
    `${api}/${creator}/classroom/${classroom}`,
    "GET",
  );
  return response;
}


// The API returns one page at a time, so follow lastEvaluatedKey until every page
// is loaded. A cursor that comes back again would loop forever, so it's an error
// rather than a silently partial list.
export async function getClassroomDiscussions({ classroom }) {
  const items = [];
  const seenKeys = new Set();
  let response;
  let lastEvaluatedKey;
  do {
    const query = lastEvaluatedKey
      ? `?lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`
      : "";
    response = await apiRequest(
      `${api}/classroom/${classroom}${query}`,
      "GET",
    );
    items.push(...(response?.items || []));
    lastEvaluatedKey = response?.lastEvaluatedKey;
    if (lastEvaluatedKey && seenKeys.has(lastEvaluatedKey)) {
      throw new Error(
        `Classroom ${classroom} discussions repeated a page cursor; refusing partial results`,
      );
    }
    if (lastEvaluatedKey) seenKeys.add(lastEvaluatedKey);
  } while (lastEvaluatedKey);
  return { ...response, items, count: items.length };
}

export async function updateMeeting({
  meetingId,
  creator,
  classroomId,
  values,
}) {
  try {
    const response = await apiRequest(
      `${api}/${creator}/${meetingId}?classroomId=${classroomId}`,
      "PATCH",
      values,
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteMeeting({ creator, meetingId, classroomId }) {
  try {
    const response = await apiRequest(
      `${api}/db/${creator}/${meetingId}?classroomId=${classroomId}`,
      "DELETE",
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function createMeeting(body) {
  try {
    const response = await apiRequest(`${api}`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function scheduleMeeting(body) {
  try {
    const response = await apiRequest(`${api}/schedule`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function startTranscribe(body) {
  try {
    const response = await apiRequest(`${api}/transcribe`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function stopTranscribe(body) {
  try {
    const response = await apiRequest(`${api}/transcribe/stop`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function saveTranscribe(body) {
  try {
    const response = await apiRequest(`${api}/transcribe/save`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function gradeConversation(body) {
  try {
    const response = await apiRequest(`${api}/grade`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getTranscriptUrl({
  creator,
  meetingId,
  extMeetingId,
  meetingCreator,
  classroomId,
}) {
  try {
    const response = await apiRequest(
      `${api}/transcribe/${creator}/${meetingCreator}/${meetingId}/${extMeetingId}?classroomId=${classroomId}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}
